import { getResourceFromCms } from '@namespace/helpers';

export const getCmsTranslations = (lang, { timeout = 30_000, ...other } = {}) =>
  getResourceFromCms(`/translations/${lang}`, { timeout, ...other });
